<template>
  <div>
    <div class="vx-col w-full">
      <ul class="heading-ul mb-5">
        <li>
          <router-link to="/setup/service-products/products" class="vx-row">
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            <h4>{{ $t("setup.label.CreateProduct") }}</h4>
          </router-link>
        </li>
      </ul>
    </div>
    <ValidationObserver ref="observer">
      <div class="vx-row">
        <vx-card>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.Code')"
              >
                <vs-input
                  :label="$t('setup.label.Code')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="service.productCode"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/4 md:w-1/4 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.Status")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.Status')"
                >
                  <v-select
                    label="value"
                    v-model="service.status"
                    :options="productTemplate.status"
                    :reduce="(serviceType) => serviceType.value"
                    :placeholder="$t('placeholder.label.SelectOne')"
                  >
                    <template v-slot:option="option">{{
                      option.value
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div
              class="vx-col w-full lg:w-1/4 md:w-1/4 sm:w-full xs:w-full pl-4 pt-3"
            >
              <vs-checkbox class="mt-3" v-model="service.isBouquet"
                >{{ $t("setup.label.Bouquet") }}
              </vs-checkbox>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.Description')"
              >
                <vs-input
                  :label="$t('setup.label.Description')"
                  class="w-full mb-2 font-semibold starlabel"
                  :placeholder="$t('setup.label.Enter_product_Description')"
                  v-model="service.productDescription"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.Type")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.Type')"
                >
                  <v-select
                    label="serviceCode"
                    v-model="service.serviceId"
                    :options="productTemplate.serviceDatas"
                    :reduce="(serviceType) => serviceType.id"
                    :placeholder="$t('placeholder.label.SelectOne')"
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <!-- <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.ExternalProductId")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules=""
                  v-slot="{ errors }"
                  name="external product id"
                >
                  <v-select
                    label="productName"
                    v-model="service.externalProductId"
                    :options="ExternalProductsList || []"
                    :reduce="(obj) => obj.productId"
                    placeholder="--Select One--"
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div> -->
          </div>
          <div
            class="vx-row p-8"
            style="margin-top: 20px"
            v-if="service.serviceId"
          >
            <vs-divider />
            <div class="md:w-1/6">
              <div class="flex items-end px-3 pt-3">
                <span class="font-medium text-lg leading-none"
                  >{{ $t("setup.label.ProductParameter")
                  }}<span class="required"> *</span></span
                >
              </div>
            </div>
            <div class="md:w-5/6">
              <div class="vx-col w-full md:w-11/12">
                <div class="vx-row">
                  <div class="vx-col w-full md:w-1/4">
                    <v-select
                      label="mCodeValue"
                      v-model="createProductObj.paramName"
                      :options="productTemplate.serviceParamsData"
                      :reduce="(serviceType) => serviceType.id"
                      :placeholder="$t('setup.label.ParamName')"
                    >
                      <template v-slot:option="option">{{
                        option.mCodeValue
                      }}</template>
                    </v-select>
                  </div>
                  <div class="vx-col w-full md:w-1/4">
                    <v-select
                      label="value"
                      v-model="createProductObj.paramCategory"
                      :options="['P', 'S']"
                      :placeholder="$t('setup.label.Category')"
                    >
                      <template v-slot:option="option">{{
                        option.value
                      }}</template>
                    </v-select>
                  </div>
                  <div class="vx-col w-full md:w-1/4">
                    <v-select
                      label="value"
                      v-model="createProductObj.paramType"
                      :options="paramType"
                      @input="createProductObj.paramValue = ''"
                      :placeholder="$t('setup.label.Type')"
                    >
                      <template v-slot:option="option">{{
                        option.value
                      }}</template>
                    </v-select>
                  </div>
                  <div
                    class="vx-col w-full md:w-1/6"
                    v-if="createProductObj.paramType"
                  >
                    <vs-input
                      v-if="
                        createProductObj.paramType == 'Text' ||
                        createProductObj.paramType == 'Combo' ||
                        createProductObj.paramType == 'Password' ||
                        createProductObj.paramType == 'Query'
                      "
                      :placeholder="$t('setup.label.EnterValue')"
                      v-model="createProductObj.paramValue"
                      class="w-full mb-2 font-semibold padding-zero"
                    />
                    <datepicker
                      v-if="createProductObj.paramType == 'Date'"
                      :placeholder="$t('placeholder.label.SelectDate')"
                      v-model="createProductObj.paramValue"
                      class="mb-2 font-semibold"
                    />
                    <v-select
                      v-if="createProductObj.paramType == 'Boolean'"
                      label="value"
                      v-model="createProductObj.paramValue"
                      :options="[true, false]"
                      :placeholder="$t('placeholder.label.SelectOne')"
                    >
                      <template v-slot:option="option">{{
                        option.value
                      }}</template>
                    </v-select>
                  </div>
                  <div class="vx-col w-full md:w-1/12">
                    <div class="whitespace-no-wrap p-3">
                      <feather-icon
                        icon="PlusIcon"
                        title="add"
                        v-if="
                          createProductObj.paramName &&
                          createProductObj.paramCategory &&
                          createProductObj.paramType
                        "
                        svgClasses="w-5 h-5 hover:text-primary stroke-current cursor"
                        @click.stop="addItem()"
                        class="icon_row"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <vs-divider />
            <vs-table :data="service.productArray" class="w-full">
              <template slot="thead">
                <vs-th colspan="12">
                  <div class="vx-row w-full">
                    <div class="vx-col w-full md:w-11/12">
                      <div class="vx-row w-full">
                        <div class="vx-col w-full md:w-1/4 center">
                          {{ $t("setup.label.ParamName") }}
                        </div>
                        <div class="vx-col w-full md:w-1/4 center">
                          {{ $t("setup.label.ParamType") }}
                        </div>
                        <div class="vx-col w-full md:w-1/4 center">
                          {{ $t("setup.label.ParamCategory") }}
                        </div>
                        <div class="vx-col w-full md:w-1/4 center">
                          {{ $t("setup.label.ParamValue") }}
                        </div>
                      </div>
                    </div>
                    <div class="vx-col w-full md:w-1/12 center">
                      {{ $t("setup.label.Action") }}
                    </div>
                  </div>
                </vs-th>
              </template>
            </vs-table>
            <div
              class="vx-row w-full mb-2 mt-4"
              v-for="(n, i) in service.productArray"
              :key="n"
            >
              <div class="vx-col w-full md:w-11/12">
                <div class="vx-row">
                  <div class="vx-col w-full md:w-1/4">
                    <v-select
                      label="mCodeValue"
                      v-model="service.productArray[i].paramName"
                      :options="productTemplate.serviceParamsData"
                      :reduce="(serviceType) => serviceType.id"
                      :placeholder="$t('placeholder.label.SelectOne')"
                    >
                      <template v-slot:option="option">{{
                        option.mCodeValue
                      }}</template>
                    </v-select>
                  </div>
                  <div class="vx-col w-full md:w-1/4">
                    <v-select
                      label="value"
                      v-model="service.productArray[i].paramCategory"
                      :options="['P', 'S']"
                      :placeholder="$t('placeholder.label.SelectOne')"
                    >
                      <template v-slot:option="option">{{
                        option.value
                      }}</template>
                    </v-select>
                  </div>
                  <div class="vx-col w-full md:w-1/4">
                    <v-select
                      label="value"
                      v-model="service.productArray[i].paramType"
                      :options="paramType"
                      @input="service.productArray[i].paramValue = ''"
                      :placeholder="$t('placeholder.label.SelectOne')"
                    >
                      <template v-slot:option="option">{{
                        option.value
                      }}</template>
                    </v-select>
                  </div>
                  <div class="vx-col w-full md:w-1/4">
                    <vs-input
                      v-if="
                        service.productArray[i].paramType == 'Text' ||
                        service.productArray[i].paramType == 'Combo' ||
                        service.productArray[i].paramType == 'Password' ||
                        service.productArray[i].paramType == 'Query'
                      "
                      :placeholder="$t('setup.label.EnterValue')"
                      v-model="service.productArray[i].paramValue"
                      class="w-full mb-2 font-semibold padding-zero"
                    />
                    <datepicker
                      v-if="service.productArray[i].paramType == 'Date'"
                      :placeholder="$t('placeholder.label.SelectDate')"
                      v-model="service.productArray[i].paramValue"
                      class="mb-2 font-semibold"
                    />
                    <v-select
                      v-if="service.productArray[i].paramType == 'Boolean'"
                      label="value"
                      v-model="service.productArray[i].paramValue"
                      :options="[true, false]"
                      :placeholder="$t('placeholder.label.SelectOne')"
                    >
                      <template v-slot:option="option">{{
                        option.value
                      }}</template>
                    </v-select>
                  </div>
                </div>
              </div>
              <div class="vx-col md:w-1/12">
                <feather-icon
                  class="icon_row text-danger pt-3 pl-2 icon_row"
                  icon="TrashIcon"
                  svgClasses="w-5 h-5 text-danger stroke-current cursor"
                  color="danger"
                  :title="$t('setup.label.Delete')"
                  type="border"
                  @click.stop="removeItem(i)"
                  size="small"
                ></feather-icon>
              </div>
            </div>

            <div class="vx-row" style="margin-left: auto; margin-right: auto">
              <div class="vx-col"></div>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="resetForm"
            >{{ $t("setup.label.Reset") }}</vs-button
          >
          <vs-button
            class="mr-3 mb-2 footerButton-next"
            @click="createproduct"
            >{{ $t("setup.label.Submit") }}</vs-button
          >
        </div>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Multiselect from "vue-multiselect";
import vSelect from "vue-select";
import { mapState } from "vuex";

const serviceEmptyObj = {
  serviceId: "",
  status: "",
  productCategory: "",
  productCode: "",
  // externalProductId: "",
  productDescription: "",
  isBouquet: false,
  productArray: [],
};
const emptyCreateProduct = {
  paramName: "",
  paramCategory: "",
  paramType: "",
  paramValue: "",
};
export default {
  data() {
    return {
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      service: serviceEmptyObj,
      serviceTemplateData: {},
      serviceType: [],
      createProductObj: emptyCreateProduct,
      productArray: [],
      paramType: ["Text", "Combo", "Date", "Boolean", "Password", "Query"],
    };
  },
  components: {
    Datepicker,
    "v-select": vSelect,
    Multiselect,
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    ...mapState({
      productTemplate: (state) => state.serviceProducts.productTemplate,
      // ExternalProductsList: (state) => state.serviceProducts.externalProducts,
    }),
  },
  methods: {
    addItem() {
      this.service.productArray = [
        this.createProductObj,
        ...this.service.productArray,
      ];
      this.createProductObj = {
        paramName: "",
        paramCategory: "",
        paramType: "",
        paramValue: "",
      };
    },
    removeItem(i) {
      this.service.productArray.splice(i, 1);
    },
    async getProductTemplateFunc() {
      try {
        await this.$store.dispatch("serviceProducts/setProductTemplate");
      } catch (e) {
        this.$toasted.error(e.message);
      }
    },
    async createproduct() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      if (this.service.productArray.length == 0) {
        this.warningPopup = true;
        this.errorMessage = "";
        this.warningText = "Please add Product Parameter";
        return;
      }
      try {
        this.service.productCategory = "P";
        await this.$store.dispatch(
          "serviceProducts/createProductAction",
          this.service
        );
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Product Created Successfully!",
          type: "success",
        });
        this.resetForm();
        this.$router.push(`/setup/service-products/products`);
      } catch (error) {
        const errorMessage = String(error).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
    resetForm() {
      this.service = {
        serviceId: "",
        status: "",
        productCategory: "",
        productCode: "",
        productDescription: "",
        productArray: [],
      };
      this.createProductObj.paramName = "";
      this.createProductObj.paramCategory = "";
      this.createProductObj.paramType = "";

      if (this.$refs.observer) {
        this.$refs.observer.reset(); 
      }
    },
    async getExternalProductsMethod() {
      try {
        await this.$store.dispatch("serviceProducts/getExternalProductsAction");
      } catch (e) {
        this.$swal({
          title: "Error",
          icon: "error",
          text: "Unable To Fetch Enternal Products!",
          type: "error",
        });
      }
    },
    cancel() {
      this.$router.push(`/setup/service-products/products`);
    },
  },
  mounted() {
    this.resetForm();
    this.getProductTemplateFunc();
    // this.getExternalProductsMethod();
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.multiselect__tag {
  color: rgb(48, 48, 48);
  background-color: rgba(250, 250, 250, 0.1);
  font-size: 01rem;
}
.multiselect__tag:hover {
  background-color: rgba(var(--vs-warning), 0.3);
}

.multiselect__option--disabled {
  background: purple;
  color: rgba(var(--vs-primary), 1);
  font-style: italic;
}

.multiselect__option--highlight {
  background-color: rgba(var(--vs-primary), 1);
  color: rgb(255, 255, 255);
  font-size: 0.9rem;
  height: 1rem;
}

.multiselect__content {
  background: rgb(255, 255, 255);
  color: #444;
  font-size: 0.9rem;
}
.multiselect__single {
  height: 0.8rem;
  font-size: 01rem;
  color: #444;
}
.multiselect__tag {
  position: relative;
  display: inline-block;
  padding: 0.25rem 1.625rem 0.25rem 0.625rem;

  margin-right: 0.625rem;

  line-height: 1;

  margin-bottom: 0.5rem;
}
.padding-zero {
  padding-top: 0px;
}
</style>
